export const defaultEntranceAnimationDuration = 300;
export const defaultExitAnimationDuration = 100;
export const durationPerCharInMs = 50;
export const minDurationInMs = 3000;
export const maxDurationInMs = 10000;
